import {StandingsWidgetController} from "../standings-widget.controller";
import {STANDINGS_WIDGET} from "../standings-widget.consts";
import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {StandingsWidgetGroupedRowsViewModel} from "../models/standings-widget.grouped-rows-view-model";

export class StandingsWidgetToggleGroupHandler extends ActionHandler {
  controller: StandingsWidgetController;
  type = STANDINGS_WIDGET.ACTION_TYPES.toggleGroup;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    const group: StandingsWidgetGroupedRowsViewModel = params.group;

    group.isCollapsed = !group.isCollapsed;
  }
}
